// src/loom/site/types.ts
var LoomSiteAriResourceOwner = "loom", LoomSiteAriResourceType = "site";

export {
  LoomSiteAriResourceOwner,
  LoomSiteAriResourceType
};
